/** "Proposals/P-2/Coir_20261014T120000.pdf" → "Coir.pdf" (the upload time stamp only keeps keys unique). */
export const docName = (key: string) => (key.split('/').pop() || key).replace(/_\d{8}T\d{6}(?=\.[^.]+$)/, '');
